import { Component, Input } from "@angular/core";
import { Table, TableModule } from "primeng/table";
import { exportExcel } from "../../../../core/services/shared.service";
import { CommonModule } from "@angular/common";
import { InputTextModule } from "primeng/inputtext";
import { DropdownModule } from "primeng/dropdown";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { CommissionProgramTierData } from "../../../../core/models/bcLedgers/commissionProgramTierDataDto";

@Component({
  selector: "jni-commision-program-tier",
  templateUrl: "./commision-program-tier.component.html",
  styleUrls: ["./commision-program-tier.component.scss"],
  imports: [
    TableModule,
    CommonModule,
    InputTextModule,
    DropdownModule,
    ButtonModule,
    CardModule,
  ],
})
export class CommisionProgramTierComponent {
  @Input() commissionProgramTierLists: CommissionProgramTierData[] = [];
  fileName = "Commission Program Tier";
  clearTable(table: Table) {
    table.clear();
  }
  exportExcelFile() {
    exportExcel(this.commissionProgramTierLists, this.fileName);
  }
}
